import axios from "axios";
import { loadToken } from "../component/action/preferences";
// console.log("VITE_API_URL:", import.meta.env.VITE_API_URL);
// console.log("VITE_TEST:", import.meta.env.VITE_TEST);
import { Preferences } from "@capacitor/preferences";
import { loadLanguage } from "../component/action/preferences";
import appConfig from "./../appconfig.json";

const api = axios.create({
  baseURL: appConfig.apiBaseUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(async (config) => {
  config.headers["token"] = (await loadToken()) || null;

  // Always send country id
  config.headers["country-id"] = 1;

  // config.params = { ...config.params, locale: localStorage.getItem("lng") ?? "en" };
  // const { value } = await Preferences.get({ key: "language" });
  const value = await loadLanguage();
  config.params = { ...config.params, locale: value || "en" };
  return config;
});

export default api;
